export default "__VITE_ASSET__BC1XO3_a__"